var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lyricsContainer",staticClass:"lyrics-container"},[_c('div',{staticClass:"lyrics"},_vm._l((_vm.lyrics),function(line,index){return _c('p',{key:index,ref:"lyricsLine",refInFor:true,class:{ active: index === _vm.currentLine }},[_vm._v(" "+_vm._s(line)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }